import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  standalone: true,
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SkeletonLoaderComponent {}
